<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="電子票券搜尋處理"
      fkey="tm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div class="wrapper2" ref="wrapper" @scroll="handleScroll">
      <b-table :stacked="checkMobile()" ref="scrollarea" class="" striped hover :items="items" :fields="fields" @scrolldownend="searchTickets(true)" show-empty >
        <template slot="empty">
          目前都沒有資料喔
        </template>
        <template v-slot:cell(confirm_use_status)="row">
          {{row.item.confirm_use_status==='running'?'未使用':''}}
          {{row.item.confirm_use_status==='cancelled'?'已退票':''}}
          {{row.item.confirm_use_status==='confirmed'?'已使用':''}}
          {{row.item.confirm_use_status==='untrust_confirmed'?'已使用':''}}
          {{row.item.confirm_use_status==='partial_used'?'已部分使用':''}}
          {{row.item.ticket_type==='line'?'(酷券)':''}}
          {{row.item.ticket_type==='paper'?'(紙本)':''}}
          {{row.item.ticket_type==='external'?'('+row.item.ext_sub_type+')':''}}
        </template>
        <template v-slot:cell(actions)="row" style="text-align:left;">
          <b-button v-if="row.item.confirm_use_status==='running'&&!row.item.in_reserving&&row.item.buyer_mi==row.item.user_mi&&showDispatchOption" @click="dispatchTicket(row.item)" size="sm" class="mr-1">            
            客服分票
          </b-button>
          <b-button v-if="row.item.confirm_use_status==='running'&&!row.item.in_reserving&&row.item.buyer_mi!=row.item.user_mi&&row.item.ticket_type==='electronic'&&showDispatchOption" @click="returnTicket(row.item)" size="sm" class="mr-1">
            手動強制還給原購人
          </b-button>
          <b-button v-if="(row.item.confirm_use_status==='running'||row.item.confirm_use_status==='partial_used')&&showExtendTime&&row.item.ticket_type!=='paper'" @click="resqueQRCode(row.item)" size="sm" class="mr-1">
            QRCode延長
          </b-button>
          <b-button v-if="(row.item.confirm_use_status==='requesting' || row.item.confirm_use_status==='running'||row.item.confirm_use_status==='partial_used')&&showPostConfirm&&row.item.ticket_type!=='paper'" @click="showPostConfirmModalPopup(row.item)" class="mr-1">
            補核銷
          </b-button>
          <b-button @click="showDetail(row.item)">詳細</b-button>
        </template>
      </b-table>
    </div>
    <b-modal
      id="detailModal"
      ref="ticketModal"
      v-model="modalShow" 
      centered
      size="lg"
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="票券狀態詳細"
        fkey="ts01"
        ref="detailForm"
        populateOptionVar="detailOptions"
        :parentVue="this"
        formDataObjVar="detailData"
      />
    </b-modal>
    <b-modal
      id="detailModal"
      ref="ticketModal"
      v-model="showPostConfirmModal" 
      centered
      size="lg"
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="補核銷"
        fkey="pc01"
        ref="postConfirmForm"
        populateOptionVar="postConfirmOptions"
        :parentVue="this"
        formDataObjVar="postConfirmData"
      />
    </b-modal>
    <b-modal
      id="dispatchModal"
      ref="dispatchModal"
      v-model="modalShowDispatch" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="指定MI分票"
        fkey="dt01"
        ref="dispatchForm"
        populateOptionVar="dispatchOptions"
        :parentVue="this"
        formDataObjVar="dispatchData"
      />
    </b-modal>
  </div>
</template>

<script>

import { 
  apiListToExcel,
  apiDownloadFile,
 } from '@/api/Util.js'

import {
  apiSetupMerchantTicket
} from '@/api/AdminManage.js'

import {
  apiSearchTicketList,
  apiGetTicketInfoForCsPostConfirm,
  apiConfirmUseTicket,
  apiDispatchTicket,
  apiReturnDispatchedTicket,
  apiRescueTicketQRCode
} from '@/api/CustomerServices.js'

export default {
  name: 'TicketProcess',
  components: {
  
  },
  data: function () {
    return {
      ext_bill_id:'',
      showDispatchOption:false,
      showExtendTime:false,
      showPostConfirm:false,
      showPostConfirmModal:false,
      btnIndex:0,
      dispatchIconIndex:0,
      extendIconIndex:0,
      confirmIconIndex:0,
      postConfirmStores:[],
      postConfirmServices:[],
      postConfirmOptions:[
        {
          componentType:'span',
          col:2,
          placeholder:'票號'          
        },
        {
          componentType:'text',
          col:3,
          akey:'ticket_no',
          disabled:true
        },
        {
          componentType:'b-form-select',
          akey:'SelectedService',
          col:7,
          optionVar:'postConfirmServices',
          optionLabel:"service_name"
        },
        {
          componentType:'span',
          col:2,
          placeholder:'持票人'
        },
        {
          componentType:'text',
          akey:'use_name',
          col:3,
          disabled:true
        },
        {
          componentType:'b-form-select',
          akey:'SelectedStore',
          col:7,
          optionVar:'postConfirmStores',
          optionLabel:"store_name"
        },
        {
          componentType:'date-picker',
          akey:'postConfirmDate',
          col:3,
          placeholder:'核銷日期',
          //defaultValue:this.getDateByStr('',0,'-'),
          datePickerConfig: {
            format:'YYYY-MM-DD',
            useCurrent:false,
            // 加一天...因為這個組件有bug,剛打開時選取最後一天選不進去,要先有其他值才能選得到最後一天
            maxDate: this.getDateByStr('',1,'-'),
          }
        },
        {
          componentType:'vue-timepicker',
          akey:'postConfirmTime',
          col:5,
          placeholder:'核銷時間',
          defaultValue:"00:00",
          minuteInterval:5,
          minHour:6,
          maxHour:23,
        },
        {
          componentType:'span',
          col:4
        },
        {
          componentType:'text',
          akey:'postConfirmRemark',
          col:12,
          placeholder:"填寫補核銷說明備註"
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:1
            },
            {
              col:4,
              placeholder:'取消',
              execCallback:()=>{this.showPostConfirmModal = false}
            },
            {
              col:1
            },
            {
              col:5,
              placeholder:"確認補核銷",
              execCallback:this.confirmPostConfirm,
            },
          ]
        }
        
      ],
      postConfirmData:{},
      modalShowDispatch:false,
      dispatchData:{},
      dispatchOptions:[
        {
          componentType:'text',
          akey:'target_user_MI',
          col:6,
          placeholder:'分票對象的MI'
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'分票',
          execCallback:this.dispatchTicketConfirm,
          waitClick:true,
        }
      ],
      detailData: {},
      detailOptions: [
        {
          componentType:"span",
          placeholder:"票號",
          col:2
        },
        {
          componentType:"text",
          akey:'ticket_no',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"TN票號",
          col:2
        },
        {
          componentType:"text",
          akey:'ticket_id',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"PI",
          col:2
        },
        {
          componentType:"text",
          akey:'product_id',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"預約id",
          col:2
        },
        {
          componentType: "text",
          akey: 'reserve_id',
          placeholder: "",
          col:4,
          disabled: true
        },
        {
          componentType:"span",
          placeholder:"產票於",
          col:2
        },
        {
          componentType:"text",
          akey:'print_time',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"訂單",
          col:2
        },
        {
          componentType:"text",
          akey:'bill_id',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:'span',
          col:2,
          placeholder:'使用狀態',
          title:"requesting:空白票待取號 running:未使用 confirmed:已核銷 dispatching:分票待領取 cancelled:已退票 partial_used:多次使用已使用未用畢"
        },
        {
          componentType:'text',
          akey:'confirm_use_status',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"優惠期限",
          col:2
        },
        {
          componentType:'text',
          akey:'project_due_date',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人",
          col:2
        },
        {
          componentType:'text',
          akey:'use_name',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人MI",
          col:2
        },
        {
          componentType:'text',
          akey:'user_mi',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人手機",
          col:2
        },
        {
          componentType:'text',
          akey:'user_mobile',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用人mail",
          col:2
        },
        {
          componentType:'text',
          akey:'user_email',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_name',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人MI",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_mi',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人手機",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_mobile',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"購買人mail",
          col:2
        },
        {
          componentType:'text',
          akey:'buyer_mail',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"使用時間",
          col:2
        },
        {
          componentType:'text',
          akey:'use_time',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"用於店家",
          col:2
        },
        {
          componentType:'text',
          akey:'used_in_store_name',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"回兌狀態",
          col:2
        },
        {
          componentType:'text',
          akey:'writeoff_status',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"回兌時間",
          col:2
        },
        {
          componentType:'text',
          akey:'writeoff_time',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"產票來源",
          col:2,
          title:"目前非mana產的票目前在mana查不到,也不會在mana做核銷回兌"
        },
        {
          componentType:'text',
          akey:'ticket_version',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"信託碼",
          col:2
        },
        {
          componentType:'text',
          akey:'credit_no',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"外部訂單",
          col:2,
          title:"mana產票匯入者是外部匯入訂單會有此外部訂單id,尚峪下單先透過mana出貨的訂單id會在這裡"
        },
        {
          componentType:'text',
          akey:'ext_bill_id',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"作廢時間",
          col:2
        },
        {
          componentType:'text',
          akey:'cancel_time',
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"備註歷程",
          col:2
        },
        {
          componentType:'textarea',
          akey:'memo',
          col:10,
          disabled:true
        },
      ],
      filterData: {},
      filterOptions: [
        {
          componentType:'text',
          defaultValue:'',
          akey:'bill_id',
          col:3,
          placeholder:'訂單編號',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          defaultValue:'',
          akey:'member_id',
          col:3,
          placeholder:'使用者MI',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          defaultValue:'',
          akey:'from_member_id',
          col:3,
          placeholder:'購票人MI',
          execCallback:this.searchTickets,
        },
        {
          componentType:'b-form-select',
          akey:'confirm_use_status',
          col:3,
          defaultValue:'',
          dataOptions:[{value:'',text:'全部使用狀態'},{value:'running',text:'未使用'},{value:'confirmed',text:'已核銷'},{value:'dispatching',text:'分票待領中'},{value:'cancelled',text:'已退票'},{value:'partial_used',text:'已部分使用'}],
          placeholder:'篩選票券狀態',
          execCallback:this.searchTickets,
        },
        {
          componentType:'date-picker',
          defaultValue:'',
          akey:'print_from',
          col:3,
          placeholder:'搜尋產票日期起',
          execCallback:this.searchTickets,
        },
        {
          componentType:'date-picker',
          defaultValue:'',
          akey:'print_to',
          col:3,
          placeholder:'搜尋產票日期迄',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'ticket_no',
          defaultValue:'',
          col:3,
          placeholder:'用完整AA票號找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'line_code',
          defaultValue:'',
          col:3,
          placeholder:'用酷券條碼找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'product_id',
          defaultValue:'',
          col:3,
          placeholder:'用商品PI找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'reserve_id',
          defaultValue:'',
          col:3,
          placeholder:'用預約id找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'b-form-select',
          akey:'ticket_type',
          col:3,
          defaultValue:'',
          dataOptions:[{value:'',text:'全部票券類型'},{value:'electronic',text:'電子票'},{value:'paper',text:'紙本'},{value:'line',text:'Line酷券'},{value:'external',text:'賣斷外部電子票'}],
          placeholder:'篩選票券類型',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          akey:'ticket_id',
          defaultValue:'',
          col:3,
          placeholder:'用TN票號找',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          col:3,
          akey:'total',
          disabled:true
        },
        {
          componentType:'b-button',
          col: 1,
          placeholder:"搜尋",
          execCallback:this.searchTickets
        },
        {
          componentType:'btn-group',
          akey:'btn-group',
          centerText: true,
          customTextAlign: 'left',
          col:12,
          buttons:[
            {
              col:2,
              // akey inside btn-group不會被放入data object
              akey:'showDispatchOption',
              btnIcon:'exchange-alt',
              placeholder:"分票",
              title:"分票",
              execCallback:this.switchDispatchOption
            },
            // {
            //   col:2,
            //   // akey inside btn-group不會被放入data object
            //   akey:'showExtendTime',
            //   btnIcon:'clock',
            //   placeholder:"延長QRCode",
            //   title:"延長QRCode",
            //   execCallback:this.switchExtendTime
            // },
            {
              col:2,
              akey:'showPostConfirm',
              btnIcon:'first-aid',
              placeholder:"補核銷功能",
              title:"補核銷功能",
              execCallback:this.switchPostConfirm
            },
            {
              col:2,
              akey:'downloadBtn',
              btnIcon:'download',
              placeholder:"下載報表",
              execCallback:this.downloadReport
            },
          ]
        },

      ],
      showFilter: true,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      QueryStartDate: null,
      QueryEndDate: null,
      modalShow: false,
      editingRow: {},
      editingIndex: 0,
      items: [],
      pageNumber:0,
      itemsPerPage:50,
      hasMore:true,
      isLoading:false,
      fields: [
        {
          key: 'product_id',
          label: 'PI',
          sortable: false
        },
        {
          key: 'reserve_id',
          label: '預約id',
          sortable: true
        },
        {
          key: 'ticket_project_name',
          label: '課程名稱',
          sortable: false
        },
        {
          key: 'use_name',
          label: '使用者',
          sortable: false
        },
        {
          key: 'ticket_id',
          label: 'TN票號',
          sortable: true
        },
        {
          key: 'ticket_no',
          label: '票號',
          sortable: true
        },
        {
          key:'confirm_use_status',
          label:'使用狀態',
        },
        {
          key: 'actions',
          label: '功能'
        }
      ]
    }
  },
  methods: {
    handleScroll(evt) {
      // 僅偵測垂直scroll時是否scroll位置到達95%的位置,是則觸發事件(不能由div觸發需要被捲的組件觸發與偵測＝＝)
      //if ((evt.target.scrollTop/(evt.target.scrollHeight-evt.target.clientHeight)) > 0.95) {
      // 只能把計算邏輯抽到$bus而已,需要this.$refs.scrollarea這個沒辦法丟過去(若為此要把wrapper寫成獨立組件又太麻煩先這樣吧)
      if (this.calScrollRatio(evt) > 0.95) {
        this.$refs.scrollarea.$emit('scrolldownend')
      }
    },
    filterChanged (upd) {
      if (['confirm_use_status','ticket_type'].includes(upd.key)) {
        setTimeout(() => {
          this.searchTickets()
        }, 50);
      }
    },
    switchDispatchOption() {
      this.filterOptions[this.btnIndex].buttons[this.dispatchIconIndex].btnIcon = this.filterOptions[this.btnIndex].buttons[this.dispatchIconIndex].btnIcon==='lock'?'exchange-alt':'lock'
      this.showDispatchOption = !this.showDispatchOption
      this.$refs.filterForm.refreshModelVar('btn-group')
    },
    switchExtendTime() {
      this.filterOptions[this.btnIndex].buttons[this.extendIconIndex].btnIcon = this.filterOptions[this.btnIndex].buttons[this.extendIconIndex].btnIcon==='lock'?'clock':'lock'
      this.showExtendTime = !this.showExtendTime
      this.$refs.filterForm.refreshModelVar('btn-group')
    },
    switchPostConfirm() {
      this.filterOptions[this.btnIndex].buttons[this.confirmIconIndex].btnIcon = this.filterOptions[this.btnIndex].buttons[this.confirmIconIndex].btnIcon==='lock'?'first-aid':'lock'
      this.showPostConfirm = !this.showPostConfirm
      this.$refs.filterForm.refreshModelVar('btn-group')
    },
    showPostConfirmModalPopup(ticket) {
      //撈補核銷需要的選項
      let Param = {
        module:'customer_service',
        method:'getTicketInfoForCsPostConfirm',
        ticket_item_id:ticket.ticket_item_id
      }
      let vm = this
      apiGetTicketInfoForCsPostConfirm(Param).then(function(resp){
        let data = resp.data
        vm.postConfirmStores = data.data.stores
        vm.postConfirmServices = data.data.services
        vm.postConfirmData = vm.CpObj(ticket)
        vm.postConfirmData.SelectedStore = vm.postConfirmStores[0]
        vm.postConfirmData.SelectedService = vm.postConfirmServices[0]
        //因為vue-timepicker與正常的text更新數據目前沒有用,所以popup打開時先不清除上一次的值(數值清了看到的還沒清會很混亂)
        //把補核銷的modal form叫起來
        vm.showPostConfirmModal = true
      }).catch(function(error){
        let data = error.response.data
        if (data.ok == 0) {
          vm.bus.fnShowInfo("此票券不能補核銷："+data.msg)
          return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok == 0) {
      //     vm.bus.fnShowInfo("此票券不能補核銷："+data.msg)
      //     return
      //   }
      //   vm.postConfirmStores = data.data.stores
      //   vm.postConfirmServices = data.data.services
      //   vm.postConfirmData = vm.CpObj(ticket)
      //   vm.postConfirmData.SelectedStore = vm.postConfirmStores[0]
      //   vm.postConfirmData.SelectedService = vm.postConfirmServices[0]
      //   //因為vue-timepicker與正常的text更新數據目前沒有用,所以popup打開時先不清除上一次的值(數值清了看到的還沒清會很混亂)
      //   //把補核銷的modal form叫起來
      //   vm.showPostConfirmModal = true
      // }, this)
    },
    confirmPostConfirm() {
      if (!this.postConfirmData.postConfirmDate) {
        this.$refs.postConfirmForm.setFocus('postConfirmDate')
        this.$refs.postConfirmForm.triggerAlert("日期未選擇")
        return
      }
      if (!this.postConfirmData.postConfirmTime) {
        this.$refs.postConfirmForm.triggerAlert("時間未選擇")
        return
      }
      if (!this.postConfirmData.postConfirmRemark) {
        this.$refs.postConfirmForm.triggerAlert("請填一下原因事由啦")
        return
      }
      let target_scan_time = (this.postConfirmData.postConfirmDate+' '+this.postConfirmData.postConfirmTime)
      if (new Date(target_scan_time) > new Date()) {
        this.$refs.postConfirmForm.triggerAlert("不可以核銷未來的時間啦")
        return
      }
      
      //確認補核銷
      let Param = {
        module:'customer_service',
        method:'csConfirmUseTicket',
        ticket_item_id:this.postConfirmData.ticket_item_id,
        merchant_service_id:this.postConfirmData.SelectedService.merchant_service_id,
        merchant_store_id:this.postConfirmData.SelectedStore.merchant_store_id,
        remark:this.postConfirmData.postConfirmRemark,
        target_scan_time:target_scan_time
      }
      let vm = this
      apiConfirmUseTicket(Param).then(function(resp){
        vm.searchTickets()
        vm.$bus.fnShowInfo("補核銷完成")
        vm.showPostConfirmModal = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok == 0) {
          vm.$refs.postConfirmForm.triggerAlert(data.msg)
          return
        }
      })
      // this.$bus.apiCall(Param, function(data, vm) {
      //   if (data.ok == 0) {
      //     vm.$refs.postConfirmForm.triggerAlert(data.msg)
      //     return
      //   }
      //   vm.searchTickets()
      //   vm.$bus.fnShowInfo("補核銷完成")
      //   vm.showPostConfirmModal = false
      // }, this)

    },
    resqueQRCode(ticket) {
      this.$bus.fnShowConfirm(('延長此票券QRCode時效(較不安全喔)？'),() => {
        let Param = {
          'module':'customer_service',
          'method':'rescueTicketQRCode',
          'ticket_item_id':ticket.ticket_item_id
        }
        let vm = this
        apiRescueTicketQRCode(Param).then(function(resp){
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("已完成"+ticket.ticket_no+"的QRCode時效延長一天操作")
          
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        })
        vm.$bus.fnClosePopup()
        
      }, () => {
        this.$bus.fnClosePopup()
        return 
      })
    },
    searchTickets(append = false) {
      if (this.isLoading) {
        return
      }
      if (append === true) {
        if (!this.hasMore) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let Param = {
        'module':'customer_service',
        'method':'csSearchTicketList',
        'bill_id': this.filterData.bill_id.trim(),
        'member_id': this.filterData.member_id.trim(),
        'from_member_id': this.filterData.from_member_id.trim(),
        'print_from': this.filterData.print_from?this.filterData.print_from:'',
        'print_to': this.filterData.print_to?this.filterData.print_to:'',
        'ticket_no': this.filterData.ticket_no.trim(),
        'line_code': this.filterData.line_code.trim(),
        'product_id': this.filterData.product_id.trim(),
        'filter_status': this.filterData.confirm_use_status,
        'page_number':this.pageNumber,
        'items_per_page':this.itemsPerPage,
        'ticket_type':this.filterData.ticket_type,
        'ext_bill_id':this.ext_bill_id,
        'reserve_id' : Number(this.filterData.reserve_id.trim()),
        'ticket_id': this.filterData.ticket_id.trim() ? this.filterData.ticket_id.trim() : ''
      }
      this.isLoading = true
      let vm = this
      apiSearchTicketList(Param).then(function(resp){
        let data = resp.data
        if (vm.pageNumber === 1) {
          vm.items = data.data
          let total = 0
          if (data.data.length > 0) {
            total = data.data[0].total
          }
          vm.filterData.total = '共'+total+'筆'
          vm.$refs.filterForm.refreshModelVar('total')
        }
        else {
          vm.items = vm.items.concat(data.data)
        }
        if (data.data.length < vm.itemsPerPage) {
          vm.hasMore = false
        }
        vm.isLoading = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   if (vm.pageNumber === 1) {
      //     vm.items = data.data
      //     let total = 0
      //     if (data.data.length > 0) {
      //       total = data.data[0].total
      //     }
      //     vm.filterData.total = '共'+total+'筆'
      //     vm.$refs.filterForm.refreshModelVar('total')
      //   }
      //   else {
      //     vm.items = vm.items.concat(data.data)
      //   }
      //   if (data.data.length < vm.itemsPerPage) {
      //     vm.hasMore = false
      //   }
      //   vm.isLoading = false
      // }, this)
    },
    dispatchTicket(ticket) {
      // popup小表單 填寫MI
      this.dispatchData.target_user_MI = ""
      this.dispatchData.ticket_item_id = ticket.ticket_item_id
      this.$refs.dispatchForm.refreshModelVar()
      this.modalShowDispatch = true
    },
    dispatchTicketConfirm(doneCB) {
      if (!this.dispatchData.target_user_MI || this.dispatchData.target_user_MI.length !== 16) {
        this.$refs.dispatchForm.triggerAlert("分票對象MI未填寫正確(16碼)")
        doneCB()
        return
      }
      let Param = {
        'module':'customer_service',
        'method':'dispatch_ticket',
        'ticket_item_id':this.dispatchData.ticket_item_id,
        'target_user_MI':this.dispatchData.target_user_MI,
        'only_check':0
      }
      let vm = this
      apiDispatchTicket(Param).then(function(resp){
        vm.$bus.fnShowInfo("已完成分票操作")
        vm.modalShowDispatch = false
        vm.searchTickets()
        doneCB()
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$refs.dispatchForm.triggerAlert(data.msg)
          doneCB()
          return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$refs.dispatchForm.triggerAlert(data.msg)
      //     doneCB()
      //     return
      //   }
      //   vm.$bus.fnShowInfo("已完成分票操作")
      //   vm.modalShowDispatch = false
      //   vm.searchTickets()
      //   doneCB()
      // }, this)
    },
    returnTicket(ticket) {
      let vm = this
      this.$bus.fnShowConfirm(('強制歸還此票券給原購者？'),() => {
        let Param = {
          'module':'customer_service',
          'method':'csReturnDispatchedTicket',
          'ticket_item_id':ticket.ticket_item_id
        }
        apiReturnDispatchedTicket(Param).then(function(resp){
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("已完成"+ticket.ticket_no+"的歸還原購人操作")
          vm.searchTickets()
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$refs.detailForm.triggerAlert(data.msg)
            return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //     vm.$refs.detailForm.triggerAlert(data.msg)
        //     return
        //   }
        //   vm.$bus.fnClosePopup()
        //   vm.$bus.fnShowInfo("已完成"+ticket.ticket_no+"的歸還原購人操作")
        //   vm.searchTickets()
        //   return
        // }, this)
      }, () => {
        this.$bus.fnClosePopup()
        return 
      })
    },
    showDetail: function (row) {
      this.detailData = this.CpObj(row)
      let is_test = this.detailData.ticket_no.startsWith('BB')
      this.detailData.ticket_version = !is_test?(this.detailData.ticket_id.startsWith('TN')?'新流程':'Mana產票'):'測試票'
      this.detailData.credit_no = !is_test?this.detailData.ticket_check_no.substr(0,16):'沒有信託'
      this.modalShow = true
    },
    modalOK: function (doneCB) {
      if (!this.formData.service_standard_minutes || !this.formData.project_start_date || !this.formData.project_end_date) {
        this.$refs.editForm.triggerAlert("請檢查必填欄位")
        doneCB()
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'setup_merchant_ticket',
        'ticket_project_id': this.formData.ticket_project_id,
        'service_standard_minutes': this.formData.service_standard_minutes,
        'service_assert_minutes': this.formData.service_assert_minutes,
        'service_quota': 1,
        'usage_limit_per_user': 1,
        'project_start_date': this.formData.project_start_date,
        'project_end_date': this.formData.project_end_date,
        'project_extend_date': this.formData.project_extend_date?this.formData.project_extend_date:''
      }
      //service_assert_minutes只有create時才傳input的值就好,edit時帶舊值
      if (!this.formData.ticket_project_confirmed) {
        Param.service_assert_minutes = this.formData.service_standard_minutes
      }
      let vm = this
      apiSetupMerchantTicket(Param).then(function(resp){
        if (vm.formData.service_items.length > 0) {
          vm.formData.service_items[0].service_standard_minutes = parseInt(vm.formData.service_standard_minutes)
          vm.formData.service_items[0].service_assert_minutes = parseInt(vm.formData.service_standard_minutes)
        }
        else {
          vm.formData.service_items.push({'service_standard_minutes':parseInt(vm.formData.service_standard_minutes),'service_assert_minutes':parseInt(vm.formData.service_standard_minutes)})
        }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.formData.ticket_project_confirmed = 1
        vm.items[vm.editingIndex] = vm.CpObj(vm.formData)
        vm.items = vm.CpObj(vm.items)
        doneCB()
        vm.modalShow = false
        vm.$bus.fnShowInfo('設定完成')
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$refs.editForm.triggerAlert(data.msg)
            doneCB()
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$refs.editForm.triggerAlert(data.msg)
      //       doneCB()
      //       return
      //     }
      //     if (vm.formData.service_items.length > 0) {
      //       vm.formData.service_items[0].service_standard_minutes = parseInt(vm.formData.service_standard_minutes)
      //       vm.formData.service_items[0].service_assert_minutes = parseInt(vm.formData.service_standard_minutes)
      //     }
      //     else {
      //       vm.formData.service_items.push({'service_standard_minutes':parseInt(vm.formData.service_standard_minutes),'service_assert_minutes':parseInt(vm.formData.service_standard_minutes)})
      //     }
      //     // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
      //     vm.formData.ticket_project_confirmed = 1
      //     vm.items[vm.editingIndex] = vm.CpObj(vm.formData)
      //     vm.items = vm.CpObj(vm.items)
      //     doneCB()
      //     vm.modalShow = false
      //     vm.$bus.fnShowInfo('設定完成')
      // }, this)
    },
    modalCancel: function () {
      this.modalShow = false
    },
    downloadReport: async function() {
      let that = this
      if (!this.filterData.print_from || !this.filterData.print_to) {
        this.$swal({
          'title':'請選擇產票日期區間',
          'icon': 'info'
        })
        return 
      }

      this.$swal({
        'title':'產出報表中',
        'text': '請稍候',
        'icon': 'info'
      })

      let Param = {
        'module':'customer_service',
        'method':'csSearchTicketList',
        'bill_id': this.filterData.bill_id.trim(),
        'member_id': this.filterData.member_id.trim(),
        'from_member_id': this.filterData.from_member_id.trim(),
        'print_from': this.filterData.print_from?this.filterData.print_from:'',
        'print_to': this.filterData.print_to?this.filterData.print_to:'',
        'ticket_no': this.filterData.ticket_no.trim(),
        'line_code': this.filterData.line_code.trim(),
        'product_id': this.filterData.product_id.trim(),
        'filter_status': this.filterData.confirm_use_status,
        'page_number': 1,
        // Dev By Watson and Best IT INTERN HOWARD
        // 因為胖丁的程式會預設分頁，所以拿不到全部資料
        // 所以才這樣用integer最大數量取資料
        'items_per_page': 2147483646,
        'ticket_type':this.filterData.ticket_type,
        'ext_bill_id':this.ext_bill_id
      }

      let tickets = await apiSearchTicketList(Param).then(function(resp){
        let data = resp.data.data
        return data
      }).catch(function(error){
        console.log(error)
        return []
      })

      console.log(tickets)
      let params = {
        "source": tickets
      }

      let result = await apiListToExcel(params).then(function(resp){
        return resp
      })

      console.log(result)

      // 下載檔案
      let download_url = ''
      download_url = result.data.data.url.replace('/api/ticket', '')
      let file_name = that.filterData.print_from + '_' + that.filterData.print_to + '_' + that.filterData.confirm_use_status
      apiDownloadFile(download_url).then(function(resp){

        that.$swal({
          'title':'產生完成！',
          'icon': 'success'
        })

        const url = window.URL.createObjectURL(new Blob([resp.data], {type:'application/vnd.ms-excel'}));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', file_name + '.xlsx');
        document.body.appendChild(link);
        link.click();
      })
    }
  },
  created() {
    for (let i=0;i<this.filterOptions.length;i++) {
      if (this.filterOptions[i].akey && this.filterOptions[i].akey === 'btn-group') {
        this.btnIndex = i
      }
    }
    for (let j=0;j<this.filterOptions[this.btnIndex].buttons.length;j++) {
      if (this.filterOptions[this.btnIndex].buttons[j].akey === 'showDispatchOption') {
        this.dispatchIconIndex = j
      }
      if (this.filterOptions[this.btnIndex].buttons[j].akey === 'showExtendTime') {
        this.extendIconIndex = j
      }
      if (this.filterOptions[this.btnIndex].buttons[j].akey === 'showPostConfirm') {
        this.confirmIconIndex = j
      }
    }
  },
  mounted() {
    this.isLoading = true;
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.$refs.detailForm.initDefault()
    }, 100);
    setTimeout(() => {
      this.isLoading = false
      //第一次的自動載入要等isLoading變false後再跑,不然網速比較快時查詢就被isLoading擋住而沒執行了
      if (this.$bus.ext_ticket_search_order_id) {
        this.ext_bill_id = this.$bus.ext_ticket_search_order_id
        delete this.$bus.ext_ticket_search_order_id
        this.searchTickets()
        let optional_hash = location.hash.indexOf('?')!==-1?location.hash.substr(0,location.hash.indexOf('?')):location.hash
        this.resetUrlQuery(optional_hash)
      }
    }, 200);
    //不要自動撈全部,需要的自己下條件抓就好(無條件時查詢全部票券很耗資源,select total就需要近一秒)
    //this.searchTickets()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper2 {
  height: 65vh;
  overflow-y: scroll;
  border-style: inset;
}

</style>
